import React from 'react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@mui/styles';
import { withRouter } from 'react-router-dom';
import TimesheetsDashboard from '../../components/ContentComponents/Timesheets/TimesheetsDashboard';
import { WithContexts } from '../../contexts/withContexts';

const styles = () => ({});

function Timesheets(props) {
    return <TimesheetsDashboard {...props} />;
}

export default WithContexts(withRouter(withTranslation()(withStyles(styles)(Timesheets))));
